import React, { useMemo } from "react";
import { observer } from "mobx-react";
import Toggle from "../../shared/Toggle";
import Swal from "../../shared/Swal";
import "./prefs.scss";
import Select from "react-select";
import PreferencesStore from "./PreferencesViewModel";
import config from "../../config";
import { reactSelectTheme } from "../../shared/colorScheme";
import className from "../../shared/className";

const Preferences = observer((props) => {
  const store = useMemo(() => new PreferencesStore(), []);
  const selectedRole = props.store.prefs?.userPreferences?.client?.pm
    ?.preventSnippetAutoApproval
    ? "MONITOR_TECH"
    : "NURSE";
  const darkModeSet =
    typeof props.store.prefs.userPreferences.client.darkMode === "boolean";
  return (
    <div className="preferences">
      <h2>Preferences</h2>
      <section>
        <h3>Patient Monitoring</h3>
        <Toggle
          label="Sweep Mode"
          checked={props.store.prefs?.userPreferences?.client?.pm?.sweep}
          onChange={(e) => props.store.setPref("pm.sweep", e.target.checked)}
        />
        {config.pm.snippetApprovalOverride &&
        props.store.prefs?.userPreferences?.server.pm?.privileges?.includes(
          "APPROVE_SNIPPET",
        ) ? (
          <label className="for-select">
            Role:
            <Select
              styles={{
                option: (provided) => ({
                  ...provided,
                  textAlign: "left",
                }),
              }}
              options={store.roleOptions}
              value={store.roleOptions.find((r) => r.value === selectedRole)}
              onChange={(option) => {
                store.selectedRoleOption = option;
                props.store
                  .setPref(
                    "pm.preventSnippetAutoApproval",
                    option.value === "MONITOR_TECH",
                  )
                  .then(() => window.location.reload());
              }}
              theme={reactSelectTheme({ darkMode: props.store.darkMode })}
            />
          </label>
        ) : null}
      </section>
      {config.FF_DARK_MODE && (
        <section className="color-scheme">
          <Toggle
            label="Dark Mode"
            checked={!!props.store.darkMode}
            className={className({
              "dark-mode-toggle": 1,
              "is-set": darkModeSet,
            })}
            style={{
              opacity:
                typeof props.store.prefs.userPreferences.client.darkMode ===
                "boolean"
                  ? 1
                  : 0.5,
            }}
            onChange={(e) => props.store.setPref("darkMode", e.target.checked)}
          />
          <button
            {...className({
              btn: true,
              "btn-primary": darkModeSet,
              "auto-dark-mode": true,
            })}
            onClick={() => props.store.setPref("darkMode", null)}
          >
            Auto
          </button>
        </section>
      )}

      {/* This gives you a readout of everything in the user's preferences.  *
      process.env.NODE_ENV === 'development' && (
        <pre style={{ fontSize: '0.7em', textAlign: 'left' }}>
          {JSON.stringify(props.store.prefs?.userPreferences?.client, null, 2)}
        </pre>
      ) /**/}
    </div>
  );
});

export default Preferences;

export function popupPrefs() {
  this.props.store.userMenuOpen = false;
  Swal.fire({
    html: (
      <div id="prefs">
        <Preferences store={this.props.store} />
      </div>
    ),
    customClass: "prefs",
    confirmButtonText: "Done",
  });
}
